export enum CustomerTypeValues {
  Particular = 0,
  Empresa = 1
}


export enum TasacionArchivoValues {
  SinDefinir = 0,
  Expediente = 1,
  Fotos = 2,
  Informe = 3
}

export enum TipoCalculoEnum {
  SinDefinir = 0,
  Fija = 1,
  PorcTasacion = 2
}

export enum TipoInformeEnum {
  IP1, IP2, IP3, IP4, IP5
}

export enum TipoEntidadEnum {
  Prescriptor = 5
}